import { Action } from 'helpers/action-helpers';
import { LatestTermsOfUse } from 'types/latest-terms-of-use';

export const ACCEPT_TERMS = 'AcceptTermsAction';
export const TERMS_ACCEPTED = 'TermsAcceptedAction';
export const TERMS_IGNORED = 'TermsIgnoredAction';
export const DECLINE_TERMS = 'DeclineTermsAction';
export const UPDATE_USER_TERMS_ACCEPTANCE = 'UpdateUserTermsAcceptanceAction';
export const FILL_TERMS = 'FillTermsAction';

export class AcceptTermsAction extends Action {
  constructor(
    public id: string,
    public title: string,
    public username: string
  ) { 
    super(ACCEPT_TERMS);
  }
}

export class TermsAcceptedAction extends Action {
  constructor(
    public id: string
  ) { 
    super(TERMS_ACCEPTED);
  }
}

export class TermsIgnoredAction extends Action {
  constructor() { 
    super(TERMS_IGNORED);
  }
}

export class DeclineTermsAction extends Action {
  constructor(
    public id: string,
    public title: string,
    public username: string
  ) { 
    super(DECLINE_TERMS);
  }
}

export class UpdateUserTermsAcceptanceAction extends Action {
  constructor() { 
    super(UPDATE_USER_TERMS_ACCEPTANCE);
  }
}

export class FillTermsAction extends Action {
  constructor(
    public optelTerms: LatestTermsOfUse | undefined,
    public nmvsTerms: LatestTermsOfUse | undefined = undefined
  ) { 
    super(FILL_TERMS);
  }
}


// WEBPACK FOOTER //
// ./src/pages/terms-of-use/actions.ts